module.exports = __webpack_public_path__ + "img/delete_3.da06abf6.jpg";